export default {"src":"/_next/static/media/moneyBangs.3211b981.svg","height":22,"width":21,"blurWidth":0,"blurHeight":0};